<template>
	<div v-if="isVisible" class="px-4 formField">
		<v-select
			:rules="validationRules"
			v-if="hasFile"
			:tabindex="tabIndex"
			clearable
			small-chips
			readonly
			hide-details="auto"
			:label="formField.Label"
			:items="fileItems"
			v-model="selectedFile"
			@click:clear="onClearExistingFile"
		>
			<template v-slot:selection="{ item }">
				<v-chip small label color="primary">{{ item.fileName }}</v-chip>
			</template>
			<template v-slot:prepend v-if="visibleBubble || visibleHelp">
				<div v-if="visibleBubble">
					<v-tooltip
						top
						nudge-top="20"
						:open-on-click="true"
						:open-on-focus="true"
						:open-on-hover="true"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								color="primary"
								v-bind="attrs"
								v-on="on"
								:tabindex="tabIndex"
								>mdi-information-outline</v-icon
							>
						</template>
						{{ bubbleText }}
					</v-tooltip>
				</div>
				<div v-if="visibleHelp">
					<v-tooltip
						top
						nudge-top="20"
						:open-on-click="true"
						:open-on-focus="true"
						:open-on-hover="true"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								color="primary"
								v-bind="attrs"
								v-on="on"
								:tabindex="tabIndex"
								>mdi-help-circle-outline</v-icon
							>
						</template>
						{{ helpText }}
					</v-tooltip>
				</div>
			</template>
		</v-select>

		<v-file-input
			v-else
			:disabled="formField.Readonly"
			:tabindex="tabIndex"
			@change="changeValue"
			hide-details="auto"
			:label="formField.Label"
			v-model="value"
		>
			<template v-slot:selection="{}">
				<v-chip small label color="primary">{{
					record[recordKeys[0] + '_FileName']
				}}</v-chip>
			</template>
		</v-file-input>
	</div>
</template>
<script>
import formFieldMixin from '../../../../mixins/inventoryForm/formFieldMixin';
export default {
	name: 'FileField',
	props: {
		formField: Object,
	},
	mixins: [formFieldMixin],
	computed: {
		hasFile() {
			if (!this.record) return false;
			if (!this.recordKeys) return false;
			if (this.recordKeys.length > 1) return false;
			if (!this.record[this.recordKeys[0] + '_Path']) return false;
			return true;
		},
		fileItems() {
			if (!this.selectedFile) return [];
			return [this.selectedFile];
		},
	},
	data() {
		return {
			selectedFile: null,
			value: null,
		};
	},
	mounted() {
		this.defaultRules.push((v) => {
			if (this.formField.Required && !this.isBulkEdit) {
				if (!v) return false || 'The value is required';
				else return true;
			} else return true;
		});
		this.selectedFile = this.getSelectedFile();
	},
	methods: {
		onRecordChanged() {
			if (!this.hasFile) return;
			this.selectedFile = this.getSelectedFile();
			//this.selectedValue=this.getSelectedFile();
			// if(this.recordSelectedValue)
			// {
			//     this.selectedValue=this.recordSelectedValue;
			// }else
			// {
			//     this.selectedValue=null
			// }
		},
		onHideFormField() {
			//this.selectedValue=null;
		},

		getSelectedFile() {
			if (!this.hasFile) return null;
			return {
				path: this.record[this.recordKeys[0] + '_Path'],
				fileName: this.record[this.recordKeys[0] + '_FileName'],
				id: this.record[this.recordKeys[0]],
			};
		},
		onClearExistingFile() {
			let keys = [
				{ key: this.recordKeys[0] + '_Path', value: null },
				{ key: this.recordKeys[0] + '_FileName', value: null },
				{ key: this.recordKeys[0], value: null },
			];
			this.skipNextRecordUpdate = true;
			this.$emit('selectedValueChanged', keys);
		},
		changeValue(value) {
			this.selectedValue = value;
		},

		onSelectedValueChanged(newVal) {
			let filename = null;
			if (newVal) filename = newVal.name;
			let keys = [
				{ key: this.recordKeys[0] + '_FileName', value: filename },
				{ key: this.recordKeys[0], value: newVal },
			];
			this.$emit('selectedValueChanged', keys);
		},
	},
};
</script>
